<template>
  <v-navigation-drawer
    fixed
    floating
    v-model="isMainMenuOpened"
    mobile-break-point="0"
    app
    ref="nav"
    class="elevation-5"
  >

    <v-toolbar flat>
      <v-toolbar-title>{{city}}</v-toolbar-title>
    </v-toolbar>

    <a :href="logoLink" target="_blank">
        <!-- :style="{ 'filter': $store.getters.isDarkTheme ? 'brightness(150%)' : 'brightness(50%) sepia(50) saturate(3) hue-rotate(40deg)' }" -->
      <img
        :style="{filter: $store.getters.isDarkTheme ? 'invert(48%) sepia(13%) saturate(3207%) hue-rotate(90deg) brightness(95%) contrast(80%)' : ''}"
        style="width: 100%; max-height: 150px; padding: 16px; object-fit: contain;"
        :src="logoURL" alt="">
    </a>

    <!-- <v-divider></v-divider> -->
    
    <!-- <app-layerswitcher ref="layerSwitcher"></app-layerswitcher> -->

    <!-- <v-divider></v-divider> -->

    <v-divider></v-divider>

    <v-container fluid>
      <v-flex xs12>
        <app-select-indicador></app-select-indicador>
      </v-flex>
    </v-container>

    <v-divider></v-divider>

    <v-list class="pt-0">

      <v-list-tile
        @click="$store.dispatch('setActiveControl', 'Search-Component-Point')">
        <v-list-tile-action><v-icon>search</v-icon></v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ $t('consultas') }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile
        @click="$store.dispatch('setActiveControl', 'Player-Historico')">
        <v-list-tile-action><v-icon>event_note</v-icon></v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ $t('historico-de') }} {{indicador ? $t(`indicadores.${indicador}`) : ''}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile
        @click="$store.dispatch('setActiveControl', 'Comparative')">
        <v-list-tile-action><v-icon>compare</v-icon></v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{$t('comparativas')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile
        v-if="indicador && indicador.toLowerCase() == 'vegetacion'"
        @click="$store.dispatch('setActiveControl', 'Ratios-Vegetacion')">
        <v-list-tile-action><v-icon>pie_chart</v-icon></v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Ratios</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile
        @click="$store.dispatch('setActiveControl', 'Create-Search-Polygon')">
        <v-list-tile-action><v-icon>add</v-icon></v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ $t('poligonos-de-busqueda') }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-divider></v-divider>

      <app-select-theme></app-select-theme>
    </v-list>

  </v-navigation-drawer>
</template>


<script>
import config from '@/config'
import AppSelectIndicador from '../core/utils/shared-components/select-indicador'
import AppSelectTheme from '../main/SelectTheme'

export default {
  components: {
    AppSelectIndicador,
    AppSelectTheme
  },
  
  data() {
    return {
      city: config.city.name,
      logoURL: config.logo_url,
      logoLink: config.link_url,
    }
  },

  computed: {
    isMainMenuOpened: {
      get() { return this.$store.getters.isMainMenuOpened },
      set(value) { this.$store.dispatch(value ? 'openMenu' : 'closeMenu') }
    },

    indicador() {
      return this.$store.getters.indicador
    },
  }
}
</script>

<style>
  .input-group__input i.icon {
    padding-right: 0px;
  }
</style>



// WEBPACK FOOTER //
// NavigationDrawer.vue?75b68a6c